import src from "IMAGE";
export default { src, width: 592, height: 537, blurWidth: 8, blurHeight: 7, blurDataURL: "data:image/webp;base64,UklGRkYAAABXRUJQVlA4TDkAAAAvB4ABAM1VICICHogEAAAAAIABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAAQAEREngIA"};
